<template>
  <div>
    <v-container grid-list-lg fluid>
        <v-layout row wrap>
        <v-flex lg12 md12 sm12>
            <v-layout row wrap>
                <v-flex lg4 md12 sm12 pr-6 pl-lg-6>
                    <v-layout row wrap justify-end>
                        <v-menu
                            v-model="menuStart"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                v-model="computedStartDateFormatted"
                                label="Từ ngày"
                                hint="DD-MM-YYYY"
                                persistent-hint
                                prepend-icon="fa-calendar-alt"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.startDate" no-title @input="menuStart = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg4 md12 sm12 pr-6>
                    <v-layout row wrap justify-end>
                        <v-menu
                            v-model="menuEnd"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                v-model="computedEndDateFormatted"
                                label="Đến ngày"
                                hint="DD-MM-YYYY"
                                persistent-hint
                                prepend-icon="fa-calendar-alt"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg4 md12 sm12 pr-6>
                    <v-btn @click="filter_data" color="#1977ff" outlined>Xem</v-btn>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex lg12 md12 sm12>
            <v-layout row wrap>
                <!-- <v-flex lg6 md12 sm12 xs12>
                    <highcharts :options="chartGMVOptions"></highcharts>
                </v-flex> -->
                <v-flex lg12 md12 sm12 xs12>
                    <highcharts :options="chartOptions"></highcharts>
                </v-flex>
            </v-layout>
        </v-flex>
        
        <v-flex lg12>
            <v-card class="mb-8">
                <v-data-table :headers="headers" hide-default-footer :sortable="false" :items="items" :server-items-length="items ? items.length : 0"  :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{item.TransactionMonth.toString().replace(/(\d{4})(\d{2})/, "$2-$1")}}</td>
                            <td class="text-end">{{ item.TotalTransaction | currency}}</td>
                            <td class="text-end"><p class="rate-p">{{ item.TotalFeeWeight | currency}}</p><p class="rate-p2">{{ item.TotalFeeWeight/item.TotalTransaction*100.0 | currency('%',2)}}</p></td>
                            <td class="text-end"><p class="rate-p">{{ item.TotalFeeBuy | currency}}</p><p class="rate-p2">{{ item.TotalFeeBuy/item.TotalTransaction*100.0 | currency('%', 2)}}</p></td>
                            <td class="text-end"><p class="rate-p">{{ item.TotalDiffExchange | currency}}</p><p class="rate-p2">{{ item.TotalDiffExchange/item.TotalTransaction*100.0 | currency('%', 2)}}</p></td>
                            <td class="text-end"><p class="rate-p">{{ item.TotalBargain | currency}}</p><p class="rate-p2">{{ item.TotalBargain/item.TotalTransaction*100.0 | currency('%', 2)}}</p></td>
                            <td class="text-end"><p class="rate-p">{{ item.TotalFeeWeight + item.TotalFeeBuy + item.TotalDiffExchange +  item.TotalBargain | currency}}</p><p class="rate-p2">{{ (item.TotalFeeWeight + item.TotalFeeBuy + item.TotalDiffExchange +  item.TotalBargain)/item.TotalTransaction*100.0 | currency('%', 2)}}</p></td>
                        </tr>
                    </template>
                    <template v-slot:body.append>
                        <tr>
                            <td class="font-weight-bold">TỔNG</td>
                            <td class="font-weight-bold text-end">{{ summary.TotalTransaction | currency }}</td>
                            <td class="font-weight-bold text-end"><p class="rate-p">{{ summary.TotalFeeWeight | currency }}</p><p class="rate-p2">{{ summary.TotalFeeWeight/summary.TotalTransaction*100.0 | currency('%',2)}}</p></td>
                            <td class="font-weight-bold text-end"><p class="rate-p">{{ summary.TotalFeeBuy | currency }}</p><p class="rate-p2">{{ summary.TotalFeeBuy/summary.TotalTransaction*100.0 | currency('%', 2)}}</p></td>
                            <td class="font-weight-bold text-end"><p class="rate-p">{{ summary.TotalDiffExchange | currency }}</p><p class="rate-p2">{{ summary.TotalDiffExchange/summary.TotalTransaction*100.0 | currency('%', 2)}}</p></td>
                            <td class="font-weight-bold text-end"><p class="rate-p">{{ summary.TotalBargain | currency }}</p><p class="rate-p2">{{ summary.TotalBargain/summary.TotalTransaction*100.0 | currency('%', 2)}}</p></td>
                            <td class="font-weight-bold text-end"><p class="rate-p">{{ summary.TotalRevenue | currency }}</p><p class="rate-p2">{{ summary.TotalRevenue/summary.TotalTransaction*100.0 | currency('%', 2)}}</p></td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import {Chart} from 'highcharts-vue';
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import { request_list } from '@/commons/hpod';
import Vue from 'vue';
import _ from "lodash";
import moment from "moment"
export default {
    components: {
        highcharts: Chart 
    },
    data() {
        let dataType = configs.DATA_TYPE;
        return {
            viewName: "bao-cao-tong-hop",
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            menuStart: false,
            menuEnd: false,
            headers: [
                {
                text: "Tháng",
                value: "TransactionMonth",
                sortable: false,
                filterable: true,
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Tổng giao dịch",
                value: "TotalTransaction",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Phí vận chuyển",
                value: "TotalFeeWeight",
                sortable: false,
                filterable: true,
                align: "end",
                values: configs.DATA_TYPE["Number"]
                },
                {
                text: "Phí mua hàng",
                value: "TotalFeeBuy",
                sortable: false,
                filterable: true,
                align: "end",
                values: configs.DATA_TYPE["Number"]
                },
                {
                text: "Chênh lệch tiền tệ",
                value: "TotalDiffExchange",
                sortable: false,
                filterable: true,
                align: "end",
                values: configs.DATA_TYPE["Number"]
                },
                {
                text: "Lợi nhuận đặt hàng",
                value: "TotalBargain",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Tổng doanh thu",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                }                
            ]
        };
    },
    computed: {
        ...mapState({
            items: state => state.report.generalReport.data,
            loading: state => state.report.loading
        }),
        computedStartDateFormatted () {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted () {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        summary() {
            var ret = {
                'TotalTransaction': _.sumBy(this.items, 'TotalTransaction'),
                'TotalFeeWeight': _.sumBy(this.items, 'TotalFeeWeight'),
                'TotalFeeBuy': _.sumBy(this.items, 'TotalFeeBuy'),
                'TotalDiffExchange': _.sumBy(this.items, 'TotalDiffExchange'),
                'TotalBargain': _.sumBy(this.items, 'TotalBargain'),
                'TotalRevenue': 0,
            };
            ret.TotalRevenue = ret.TotalFeeWeight + ret.TotalFeeBuy + ret.TotalDiffExchange +  ret.TotalBargain;
            return ret;
        },
        chartOptions() {
            var dataChart =  _.sortBy(this.items,'TransactionMonth');
            var ret = {
                chart: { type: 'line' },
                title: { text: 'Tổng doanh thu' },
                credits: { enabled: false },
                tooltip: {shared: true},
                xAxis: {
                    categories: _.map(dataChart, function(x) {return x.TransactionMonth.toString().replace(/(\d{4})(\d{2})/, "$2-$1")})
                },
                yAxis: {
                    title: {
                        text: 'Tổng tiền (VNĐ)'
                    }
                },
                plotOptions: {
                    line: {
                        dataLabels: {
                            enabled: true
                        }
                    }
                },
                series: [
                    { 
                        name: 'Phí vận chuyển',
                        data: _.map(dataChart, 'TotalFeeWeight')
                    },
                    { 
                        name: 'Phí mua hàng',
                        data: _.map(dataChart, 'TotalFeeBuy')
                    },
                    { 
                        name: 'Chênh lệch tiền tệ',
                        data: _.map(dataChart, 'TotalDiffExchange')
                    },
                    { 
                        name: 'Lợi nhuận đặt hàng',
                        data: _.map(dataChart, 'TotalBargain')
                    },
                    { 
                        name: 'Tổng doanh thu',
                        data: _.map(dataChart, function(x) {return x.TotalFeeWeight + x.TotalFeeBuy + x.TotalDiffExchange +  x.TotalBargain})
                    }
                ]
            };

            return ret;
        },
        chartGMVOptions() {
            var dataChart =  _.sortBy(this.items,'TransactionMonth');
            var ret = {
                chart: { type: 'line' },
                title: { text: 'Tổng giao dịch' },
                credits: { enabled: false },
                tooltip: {},
                xAxis: {
                    categories: _.map(dataChart, function(x) {return x.TransactionMonth.toString().replace(/(\d{4})(\d{2})/, "$2-$1")})
                },
                yAxis: {
                    title: {
                        text: 'Tổng tiền (VNĐ)'
                    }
                },
                plotOptions: {
                    line: {
                        dataLabels: {
                            enabled: true
                        }
                    }
                },
                series: [
                    { 
                        name: 'Tổng giao dịch',
                        data: _.map(dataChart, 'TotalTransaction')
                    }
                ]
            };

            return ret;
        }
    },
    methods: {
        filter_data: function () {
            var param = {
                startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
                endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT)
            };
            this.$store.dispatch("report/getGeneralReport", param);
        }
    },
    mounted() {
        this.filter_data();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    }
};
</script>
<style scoped>
.rate-p {
    margin-bottom: 0px;
    margin-top: 16px;
}
.rate-p2 {
    margin-bottom: 16px;
    margin-top: 8px;
    color: rgb(168, 168, 168);
}
</style>